document.addEventListener("DOMContentLoaded", () => {
  const links = document.querySelectorAll('a[target="_blank"]');

  links.forEach((link) => {
    // Get existing aria-label or default to empty string
    let currentLabel = link.getAttribute("aria-label") || "";

    // Avoid duplicating the message if already added
    if (!currentLabel.includes("Opens in New Tab")) {
      // Add or append the "Opens in New Tab" label
      const newLabel = currentLabel
        ? `${currentLabel}. Opens in New Tab`
        : "Opens in New Tab";

      link.setAttribute("aria-label", newLabel);
    }
  });
});

(() => {
  const patchedViews = new WeakSet();

  const patchQuickView = (widget) => {
    const view = widget?.View;
    if (!view || typeof view.pushToCart !== 'function' || patchedViews.has(view)) return;

    const pushToCart = view.pushToCart;
    view.pushToCart = function (variantOptions, action, product, ...args) {
      const modal = window.Rebuy?.Modal?.displayed?.data;
      const needsVariantSelection =
        variantOptions === 'dynamic' || (variantOptions === 'default' && this.layout === 'line');

      if (
        action === 'addToCart' &&
        modal?.type === 'variant' &&
        modal.visible === true &&
        modal.product === product &&
        product?.selected_variant?.id &&
        product.status === 'ready' &&
        product.variants?.length > 1 &&
        needsVariantSelection
      ) {
        // Rebuy quick view already selects a variant. Skip the card's first-click
        // selection gate, retaining Rebuy's submission, attribution and callbacks.
        // Remove this workaround when Rebuy fixes openQuickViewVariantModal.
        variantOptions = false;
      }

      return pushToCart.call(this, variantOptions, action, product, ...args);
    };
    patchedViews.add(view);
  };

  document.addEventListener('rebuy.ready', (event) => patchQuickView(event.detail?.widget));
  window.Rebuy?.widgets?.forEach(patchQuickView);
})();
